module.exports = __webpack_public_path__ + "assets/img/mecha-btn-204f13a8.png";